import { CouplePlanningDto, UpdateCouplePlanningDto } from 'src/dto/couple-planning.dto'
import { CouplePlanningService } from 'src/services/api/couple-planning.service'

export class CouplePlanningController {
  private service: CouplePlanningService

  constructor() {
    this.service = new CouplePlanningService()
  }

  public async getCouplePlanningList(farmId: string): Promise<CouplePlanningDto[]> {
    const response = await this.service.getCouplePlanningList(farmId)
    return response.data
  }

  public async updateCouplePlanning(
    farmId: string,
    couplePlanningDto: UpdateCouplePlanningDto
  ): Promise<CouplePlanningDto> {
    const response = await this.service.updateCouplePlanning(farmId, couplePlanningDto)
    return response.data
  }
}
